import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper } from "@components";
import { selectAvailableCountryOptions, selectBasicBusinessOptions } from "@redux";

export const MainCustomer = ({ control, customerIndex }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const businessOptions = useSelector(selectBasicBusinessOptions);

  return (
    <>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name={`mainCustom.${customerIndex}.mainCustom`}
        defaultValue={`PEN${customerIndex + 1}`}
        className="d-none"
      />

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name={`mainCustom.${customerIndex}.data.customerName`}
          title={trb(i18.Labels.CustomerName)}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`mainCustom.${customerIndex}.data.customerActivity`}
          title={trb(i18.Labels.CustomerActivity)}
          options={businessOptions}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`mainCustom.${customerIndex}.data.customerCountry`}
          title={trb(i18.Labels.CustomerCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </FullWidthInputWrapper>
    </>
  );
};
